module.exports = __webpack_public_path__ + "static/ArchiboldA-d1294f641560d2be9d2cc4d53d07d041.gif";